import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { DiscountResource } from "@exonn/js-sdk";

export const module: Module<DiscountResource> = {
  id: ResourceEnum.Discount,
  bigIcon: <span className={"icon-20-discounts"} />,
  smallIcon: <span className={"icon-15-discounts"} />,
  name: (t: TFunction) => t("moduleName.discounts"),

  tabs: {
    edit: {
      getTitle: (resource) => resource.title,
    },
  },
};
